module.exports = __webpack_public_path__ + "images/emoji/high_heel.09353600c4b8d5219f01.png";